<div class="ibox float-e-margins">
  <app-confirmation-dialog
    (confirmed)="onRemoveConfirmed()"
    (cancelled)="onRemoveCancelled()"
    >
  </app-confirmation-dialog>

  <!-- Import Modal -->
  <app-import-modal
    [showCoursesOption]="true"
    [showPlayersOption]="false"
    (importConfirmed)="onImportConfirmed($event)"
    >
  </app-import-modal>

  <div class="ibox">
    <div class="ibox-title">
      <h5>Course Management</h5>
      <div class="ibox-tools">
        <button
          type="button"
          class="btn btn-primary btn-xs"
          (click)="addCourse()"
          [disabled]="isNewCourse || isSaving"
          >
          <i class="fa fa-plus"></i> Add Course
        </button>
        @if (hasNoTournamentCourses) {
          <button
            type="button"
            class="btn btn-primary btn-xs"
            (click)="importCourses()"
          [disabled]="
            isNewCourse || isSaving || isImporting() || !canImportCourses
          "
          [title]="
            !canImportCourses
              ? 'No courses available to import from source tournament'
              : ''
          "
            style="margin-left: 5px"
            >
            <i class="fa fa-download"></i> Import Courses
          </button>
        }
      </div>
    </div>
    <div class="ibox-content">
      @if (hasNoTournamentCourses && !isNewCourse) {
        <!-- Empty State Message -->
        <div class="text-center" style="padding: 60px 20px">
          <i
            class="fa fa-golf-ball"
            style="font-size: 64px; color: #ccc; margin-bottom: 20px"
          ></i>
          <h3 style="color: #676a6c; margin-bottom: 10px">
            No Tournament Courses
          </h3>
          <p style="color: #999; font-size: 16px">
            Get started by adding a new course or importing existing courses for
            this tournament.
          </p>
        </div>
      } @else {
        <!-- Tabs Container -->
        <div class="tabs-container">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs">
            @for (course of tournamentCourses; track course) {
              <li
                [class.active]="course.courseId === tournamentCourse.courseId"
                >
                <a
              (click)="
                selectCourseTab(course.courseId); $event.preventDefault()
              "
                  >
                  <i class="fa fa-golf-ball"></i>
                  {{ course.courseName || "New Course" }}
                </a>
              </li>
            }
          </ul>

          <!-- Tab Content -->
          <div class="tab-content">
            <div class="tab-pane active">
              <div class="row">
                <!-- Course Information -->
                <div class="col-lg-12">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h5 class="panel-title">
                        <i class="fa fa-info-circle"></i> Course Information
                      </h5>
                    </div>
                    <div class="panel-body">
                      <form class="form-horizontal">
                        <div class="row">
                          <div class="col-md-8">
                            <div class="form-group">
                              <label class="col-sm-3 control-label"
                                >Course Name:</label
                                >
                                <div class="col-sm-9">
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="courseName"
                                    [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="courseForm.name"
                                    (ngModelChange)="onCourseNameChanged($event)"
                                    placeholder="Enter course name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="col-sm-4 control-label"
                                    >Short Name:</label
                                    >
                                    <div class="col-sm-8">
                                      <input
                                        type="text"
                                        class="form-control"
                                        name="courseShortName"
                                        maxlength="3"
                                        [ngModelOptions]="{ standalone: true }"
                                        [(ngModel)]="courseForm.shortName"
                                (ngModelChange)="
                                  onCourseShortNameChanged($event)
                                "
                                        placeholder="ABC"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="col-sm-2 control-label">LPGA ID:</label>
                                  <div class="col-sm-2">
                                    <input
                                      type="number"
                                      class="form-control"
                                      name="courseLpgaId"
                                      min="1"
                                      required
                                      inputmode="numeric"
                                      placeholder="Required"
                                      [ngModelOptions]="{ standalone: true }"
                                      [(ngModel)]="courseForm.lpgaId"
                                      (ngModelChange)="onCourseLpgaIdChanged($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label"
                                      >Created On:</label
                                      >
                                      <div class="col-sm-4 col-md-2">
                                        <app-audit-info
                            [dateUtc]="
                              course?.createdOnUtc ||
                              tournamentCourse.createdOnUtc
                            "
                                        ></app-audit-info>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-2 control-label"
                                        >Modified On:</label
                                        >
                                        <div class="col-sm-4 col-md-2">
                                          <app-audit-info
                            [dateUtc]="
                              course?.modifiedOnUtc ||
                              tournamentCourse.modifiedOnUtc
                            "
                                          ></app-audit-info>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>

                              <!-- Hole Information -->
                              <div class="col-lg-12">
                                <div class="panel panel-default">
                                  <div class="panel-heading">
                                    <h5 class="panel-title">
                                      <i class="fa fa-th"></i> Hole Information
                                    </h5>
                                  </div>
                                  <div class="panel-body">
                                    <app-hole-info
                                      [rounds]="rounds"
                                      [holes]="holes"
                                      [holeYardages]="holeYardages"
                                      [readOnly]="false"
                                      (holeChanged)="onHoleChanged($event)"
                                      (holeYardageChanged)="onHoleYardageChanged($event)"
                                      >
                                    </app-hole-info>
                                  </div>
                                </div>
                              </div>

                              <!-- Action Buttons -->
                              <div class="col-lg-12">
                                <div class="form-group">
                                  <div class="text-right">
                                    <button
                                      type="button"
                                      class="btn btn-danger"
                                      (click)="remove()"
                                      [disabled]="isSaving || isNewCourse"
                                      style="margin-right: 10px"
                                      >
                                      <i class="fa fa-trash"></i> Remove
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-primary"
                                      (click)="save()"
                                      [disabled]="isSaving || !canSave"
                                      >
                                      <i class="fa fa-save"></i> Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
